const namespace = "PHYSICALSHIPMENT_";

const CONSTANTS = {
  SHIPMENT_MODAL_TOGGLE: `${namespace}MODAL_TOGGLE`,

  SHIPMENT_SET_ADDRESS: `${namespace}SET_ADDRESS`,
  SHIPMENT_SET_ACTIVEADDRESS: `${namespace}SET_ACTIVEADDRESS`,
  SHIPMENT_SET_ACTIONABLEID: `${namespace}SET_ACTIONABLEID`,

  SHIPMENT_ADDRESSLIST_GET: `${namespace}ADDRESSLIST_GET`,
  SHIPMENT_ADDRESSLIST_SUCCESS: `${namespace}ADDRESSLIST_SUCCESS`,
  SHIPMENT_ADDRESSLIST_LOADING: `${namespace}ADDRESSLIST_LOADING`,
  SHIPMENT_ADDRESSLIST_ERROR: `${namespace}ADDRESSLIST_ERROR`,

  SHIPMENT_ADDRESSDATA_POST: `${namespace}ADDRESSDATA_POST`,
  SHIPMENT_ADDRESSDATA_SUCCESS: `${namespace}ADDRESSDATA_SUCCESS`,
  SHIPMENT_ADDRESSDATA_LOADING: `${namespace}ADDRESSDATA_LOADING`,
  SHIPMENT_ADDRESSDATA_ERROR: `${namespace}ADDRESSDATA_ERROR`,

  SHIPMENT_EDITADDRESSDATA_TOGGLE: `${namespace}EDITADDRESSDATA_TOGGLE`,
  SHIPMENT_EDITADDRESSDATA_PUT: `${namespace}EDITADDRESSDATA_PUT`,
  SHIPMENT_EDITADDRESSDATA_SUCCESS: `${namespace}EDITADDRESSDATA_SUCCESS`,
  SHIPMENT_EDITADDRESSDATA_LOADING: `${namespace}EDITADDRESSDATA_LOADING`,
  SHIPMENT_EDITADDRESSDATA_ERROR: `${namespace}EDITADDRESSDATA_ERROR`,

  SHIPMENT_DELETEADDRESSDATA_DELETE: `${namespace}DELETEADDRESSDATA_DELETE`,
  SHIPMENT_DELETEADDRESSDATA_SUCCESS: `${namespace}DELETEADDRESSDATA_SUCCESS`,
  SHIPMENT_DELETEADDRESSDATA_LOADING: `${namespace}DELETEADDRESSDATA_LOADING`,
  SHIPMENT_DELETEADDRESSDATA_ERROR: `${namespace}DELETEADDRESSDATA_ERROR`,
  SHIPMENT_SERVICEABLE: `${namespace}SHIPMENT_SERVICEABLE`,
  SHIPMENT_ERROR_MSG: `${namespace}SHIPMENT_ERROR_MSG`,
};

export default CONSTANTS;
